/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { store } from "@/store";
import { BotStore } from "@/store/constants";
import {
  IBlockElement,
  IIntent,
  IIntentActor,
} from "@chatcaptain/types/chatbot";
import {
  doc,
  getFirestore,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { fetchCloudRun } from "../Helper";

export const saveFaqIntent = async (
  id: string,
  name: string,
  elements: IBlockElement[],
  intelligentEnquire: IIntent["intelligent_enquire"]
): Promise<void> => {
  const chatbotId = store.getters[BotStore.Getters.GET_ID];
  await updateDoc(
    doc(getFirestore(), "dialogs/" + chatbotId + "/intents/" + id),
    {
      updated: serverTimestamp(),
      name,
      answers: elements,
      intelligent_enquire: intelligentEnquire,
    }
  );
};

export const createFaq = async (name: string): Promise<string> => {
  const chatbotId = store.getters[BotStore.Getters.GET_ID];
  const response = await fetchCloudRun(
    "https://app.chatcaptain.com/api/bot/chatbots/" + chatbotId + "/intents",
    "POST",
    {},
    {
      name,
      actor: {
        id: "faq--intern",
        name: "FAQ",
      } as IIntentActor,
      faq: true,
    }
  );
  return response.id;
};

export const deleteFaq = async (id: string): Promise<void> => {
  const chatbotId = store.getters[BotStore.Getters.GET_ID];
  await fetchCloudRun(
    "https://app.chatcaptain.com/api/bot/chatbots/" +
      chatbotId +
      "/intents/" +
      id,
    "DELETE"
  );
};
